import { render, staticRenderFns } from "./ViewFolders.vue?vue&type=template&id=e7f6d184&scoped=true&"
import script from "./ViewFolders.vue?vue&type=script&lang=ts&"
export * from "./ViewFolders.vue?vue&type=script&lang=ts&"
import style0 from "./ViewFolders.vue?vue&type=style&index=0&id=e7f6d184&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7f6d184",
  null
  
)

export default component.exports